<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import * as utils from '@/found/utils/index';
import { VXETable } from 'vxe-table';
import ImageViewer from '@/found/components/ImageViewer';
import { Loading } from 'element-ui';
import Form from './form';
import ExportModals from './components/export_modals';
import { clickVisible, pushToBusinessPlatform } from './actions';

export default {
  extends: TablePage,
  components: {
    Form,
    ExportModals,
    ImageViewer,
  },
  data() {
    return {
      // requestType: 'POST',
    };
  },
  mounted() {
    this.getConfigList('cash_withdrawal_details_list');
  },
  created() {
    VXETable.renderer.add('AdsImage', {
      // 默认显示模板
      renderDefault(_h, _renderOpts, params) {
        const { row } = params;
        return [
          <ImageViewer
            src={row.headPhotoIdCardPath}
            previewSrcList={row.headPhotoIdCardPath}
            style="width: 40px; height: 40px"
            fit="cover"
          ></ImageViewer>,
        ];
      },
    });
  },
  methods: {
    afterGetList() {
      const params = {
        menuCode: this.$store.state.menus.selectMenu,
        functionCode: 'cash_withdrawal_details_list',
      };
      request.post('/tax/v1/terminalCash/api/importFileErrorProp', params).then((res) => {
        if (res.success && res.result && res.result.length) {
          this.$confirm(
            '打款凭证上传存在失败情况，请点击【确认】进入《文件导入》页面查看失败明细，及时处理！',
            '提示',
            {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              type: 'warning',
            },
          )
            .then(() => {
              this.$router.push({
                path: '/sfa_center/file_resource_management/file_import',
              });
            })
            .catch(() => {});
        }
      });
    },
    setColumn(col) {
      const rowData = col;
      if (rowData.field === 'payFileUrl') {
        rowData.type = 'html';
        rowData.formatter = ({ row }) => `${row.payFileUrl ? `<a href=${row.payFileUrl}>${row.payFileName}</a>` : ''}`;
      }
      // if (rowData.field === 'headPhotoIdCardPath') {
      //   rowData.cellRender = { name: 'AdsImage' };
      // }
      return rowData;
    },
    clickVisible({ row, val }) {
      return clickVisible({ row, val });
    },
    modalClick({ val, row }) {
      if (val.code === 'push_to_Bus') {
        return pushToBusinessPlatform(
          row,
          request,
          (message) => this.$confirm(message, '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
          }),
          (res) => {
            this.$message.success(res.message);
            this.getList();
          },
        );
      }
      let urls = '/tax/v1/terminalCash/api/pay';
      let text = '打款';
      if (val.code === 'money') {
        if (this.selection.length === 0) {
          return this.$message.error('请先选择需要打款的数据');
        }
        request
          .post('/tax/v1/terminalCash/api/findCashAccountStatusInfo', this.selection)
          .then((res) => {
            if (res.success) {
              if (res.result.length === 0) {
                // console.log(urls, text);
                this.operationClick(urls, text);
              } else {
                let poolAccountNameList = res.result.map((v) => v.poolAccountName);
                poolAccountNameList = poolAccountNameList.toString();
                this.$confirm(`${poolAccountNameList}帐户余额不足5万元，确认打款吗?`, '提示', {
                  confirmButtonText: '确认',
                  cancelButtonText: '取消',
                  type: 'warning',
                })
                  .then(() => {
                    urls = '/tax/v1/terminalCash/api/pay';
                    text = '打款';
                    if (row.id) {
                      this.selection.push(row.id);
                    }
                    let isCash = true;
                    const list = this.tableData;
                    list.forEach((item) => {
                      this.selection.forEach((v) => {
                        if (v === item.id) {
                          if (item.cashStatus === '1') {
                            isCash = false;
                          }
                        }
                      });
                    });
                    if (!isCash) {
                      this.$message.error('本次选择数据中有提现已打款成功，请勿重复打款');
                      return false;
                    }
                    console.log(urls, text);
                    this.operationClick(urls, text);
                  })
                  .catch(() => {
                    this.$message({
                      type: 'info',
                      message: '已取消',
                    });
                  });
              }
            }
          });
      }
      if (val.code === 'repayment') {
        if (this.selection.length === 0) {
          return this.$message.error('请先选择需要重新打款的数据');
        }
        this.$confirm('确认执行自动打款吗?', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            const loadingInstance = Loading.service({ fullscreen: true, lock: true, text: '打款中...' });
            request
              .post('/tax/v1/terminalCash/api/rePay', this.selection)
              .then((res) => {
                if (res.success) {
                  this.$message({
                    type: 'success',
                    message: res.message,
                  });
                  this.selection = [];
                  this.getList();
                }
              })
              .finally(() => {
                loadingInstance.close();
              });
          })
          .catch(() => {});
      }
      if (val.code === 'check_detail') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = '支付明细';
        this.openFull();
      }
      if (val.code === 'fillin') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = '添加备注';
        this.openFull();
      }
      if (val.code === 'upload_voucher') {
        console.log(val, row);
        this.modalConfig.title = '上传打款凭证';
        this.propsObjInData = {
          functionCode: 'cash_withdrawal_details_list',
          requestUrl: this.requestUrl,
          visible: true,
          isExport: false, // false 为导入,true为导出
          configCode: val.configCode || '1',
          sid: utils.getUuid(32, 16),
          exportMessage: '',
          closeModal: this.closeModal,
        };
        console.log('propsObjInData>>>', this.propsObjInData);
        this.modalConfig.visible = true;
        this.formName = 'ExportModals';
        this.openModal();
      }
    },
    // 确认打款操作
    operationClick(urls, text) {
      console.log(urls, text);
      let datas = [];
      if (this.selection.length > 0) {
        datas = this.selection;
        request.patch(urls, datas).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: `${text}成功`,
            });
            this.selection = [];
            this.getList();
          }
        });
      } else {
        this.$message({
          type: 'error',
          message: '请选择数据',
        });
      }
    },
  },
};
</script>
